<template>
	<component :is="'h' + level" :class="`heading h${level}`">
		<slot />
	</component>
</template>

<script setup lang="ts">
	defineProps<{
		level: '1' | '2' | '3' | '4' | '5' | '6'
	}>()
</script>

<style lang="scss" scoped>
.heading {
	margin: 0;
	font-family: Montserrat, 'PT Sans', sans-serif;
	font-style: normal;
	font-weight: 700;
	line-height: 1.2;

	// Общие размеры (по умолчанию для desktop)
	&.h1 { font-size: clamp(2rem, 5vw, 4.5rem); }   // ~32px to ~72px
	&.h2 { font-size: clamp(1.75rem, 4vw, 3.5rem); } // ~28px to ~40px
	&.h3 { font-size: clamp(1.5rem, 3.5vw, 2rem); }  // ~24px to ~32px
	&.h4 { font-size: clamp(1.25rem, 3vw, 1.5rem); } // ~20px to ~24px
	&.h5 { font-size: clamp(1rem, 2.5vw, 1.25rem); } // ~16px to ~20px
	&.h6 { font-size: clamp(0.875rem, 2vw, 1rem); }  // ~14px to ~16px
}
</style>
